import { Modal } from 'react-bootstrap'

type TemplateAllProps = {
  setIsOpenModal: (open: boolean) => void
}

export default function TemplateAll({ setIsOpenModal }: TemplateAllProps) {
  return (
    <Modal show onHide={() => setIsOpenModal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title />
      </Modal.Header>
      <Modal.Body />
    </Modal>
  )
}
